(() => {
  const clamp = (input, announce = true) => {
    if (!input || !input.dataset.purchaseLimitMax) return;
    const max = parseInt(input.dataset.purchaseLimitMax, 10);
    if (!Number.isFinite(max) || max < 1) return;
    let value = parseInt(input.value || '1', 10);
    if (!Number.isFinite(value) || value < 1) value = 1;
    if (value > max) {
      input.value = String(max);
      if (announce) {
        const message = input.dataset.purchaseLimitMessage || `This product is limited to ${max} per customer.`;
        input.setCustomValidity(message);
        input.reportValidity();
        window.setTimeout(() => input.setCustomValidity(''), 1600);
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const setup = (root = document) => {
    root.querySelectorAll('input[data-purchase-limit-max]').forEach((input) => {
      clamp(input, false);
      if (input.dataset.purchaseLimitBound === '1') return;
      input.dataset.purchaseLimitBound = '1';
      input.addEventListener('input', () => clamp(input, false));
      input.addEventListener('change', () => clamp(input, true));
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.plus, [name="plus"], [data-plus-quantity-cart]');
    if (!button) return;
    const container = button.closest('quantity-input, quantity-quick-view-input, quantity-quick-shop-input, cart-update-quantity, .quantity__container, .cart-item-qty');
    if (!container) return;
    const input = container.querySelector('input[data-purchase-limit-max]');
    if (!input) return;
    const max = parseInt(input.dataset.purchaseLimitMax, 10);
    const current = parseInt(input.value || '1', 10);
    if (Number.isFinite(max) && Number.isFinite(current) && current >= max) {
      event.preventDefault();
      event.stopImmediatePropagation();
      clamp(input, true);
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const input = event.target.querySelector?.('input[data-purchase-limit-max]');
    if (input) clamp(input, true);
  }, true);

  document.addEventListener('DOMContentLoaded', () => setup());
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) setup(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
